
module.exports = {
    CONTENT_LIST_FETCH_REQUEST: 'CONTENT_LIST_FETCH_REQUEST',
    CONTENT_LIST_FETCH_SUCCESS: 'CONTENT_LIST_FETCH_SUCCESS',
    CONTENT_LIST_FETCH_FAILURE: 'CONTENT_LIST_FETCH_FAILURE',
    CONTENT_LIST_CLEAR_ERROR: 'CONTENT_LIST_CLEAR_ERROR'
};



// WEBPACK FOOTER //
// ./src/common/modules/content/constants.js